<template>
    <bill-shell>
        <section id="more" class="section py-5 bg-white">
            <div class="container text-center">
                <img style="height: 56px" src="/img/zetdc-logo.webp" alt="">
                <h1 class="text-8 font-weight-bold mb-4 mt-2">What is ZESA?</h1>
                <p class="text-3">
                    Prepaid electricity is a convenient way to be a ZESA customer in Zimbabwe. All you have
                    to do is pay for your electricity before you use it, which has many benefits. For
                    instance, there's no way you will end up owing utility companies a lot of money in
                    unpaid bills. Apart from that, you can easily monitor and control your expenditure since
                    you know precisely how many electricity units you are using and how many you are left
                    with. Lastly, that eliminates the need to wait in long queues to pay your bills since
                    you can easily buy ZESA online.
                </p>
            </div>
        </section>
        <section class="section py-5 bg-light-4">
            <div class="container">
                <h2 class="text-9 font-weight-bold mb-4 text-center">
                    Buy ZESA in Only 3 Simple Steps... <br>
                    And You'll Never Look Back!
                </h2>
                <div class="row">
                    <div class="col-md-5 col-lg-6 text-center my-auto order-2 order-md-1 px-5">
                        <img style="height: 400px" class="img-fluid rounded-lg shadow" src="/images/buy_zesa.png"
                             alt="">
                    </div>
                    <div class="col-md-7 col-lg-6 order-1 order-md-2">
                        <p class="text-3 mb-4">
                            Online payment with Magetsi is as easy as 1, 2, 3. After visiting magetsi.co.zw
                            follow these two steps to get out of the dark
                        </p>
                        <div class="row gy-4">
                            <div class="col-12 mb-2">
                                <div class="featured-box style-3">
                                    <div class="featured-box-icon text-light"><span
                                        class="w-100 text-20 fw-500">1</span></div>
                                    <h3>Enter your information</h3>
                                    <p>
                                        On the first page, enter your meter number, amount, phone number, and email
                                    </p>
                                </div>
                            </div>
                            <div class="col-12 mb-2">
                                <div class="featured-box style-3">
                                    <div class="featured-box-icon text-light"><span
                                        class="w-100 text-20 fw-500">2</span></div>
                                    <h3>Moving on...</h3>
                                    <p>Click "Buy ZESA"</p>
                                </div>
                            </div>
                            <div class="col-12 mb-2">
                                <div class="featured-box style-3">
                                    <div class="featured-box-icon text-light"><span
                                        class="w-100 text-20 fw-500">3</span></div>
                                    <h3>Confirm Payment</h3>
                                    <p>Complete the straight forward payment process and receive your tokens. No name
                                        or personal details</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <hr class="m-5 w-50 mx-auto">

                <div class="px-5 text-justify">
                    <p class="text-3 mb-4 mt-3">
                        Once you complete the transaction, Magetsi will send the token to your cell
                        phone
                        number. This transaction should not last you more than a few minutes. However,
                        since our
                        service depends on other service providers like EcoCash, we cannot guarantee a
                        set
                        transaction duration
                    </p>
                    <p class="text-3 mb-4">
                        To recharge your meter, punch the token that you receive on your phone into your
                        prepaid
                        meter. If you encounter any challenges or have any queries, get in touch with us
                        immediately using the chat widget on this page for a quick and easy solution.
                        Magetsi is
                        one of the easiest ways to buy ZESA using EcoCash.
                    </p>
                    <p class="text-3">
                        Because prepaid electricity meters show you exactly how many units are left,
                        the
                        risk of power running out unexpectedly is very low. However, no matter how
                        alert and
                        organized you might be, at one point or the other, your prepaid electricity
                        will run
                        out without you noticing, and you will be left in the dark. Well, that's if
                        it runs
                        out at night. When that happens, you can either stay in the dark all night
                        or find a
                        way to buy ZESA online. That's where Magetsi comes in
                    </p>
                    <h4 class="text-4 font-weight-bold mb-4 text-center">
                        Magetsi - The Online Self Help Service
                        for Your ZESA Token Online
                    </h4>
                    <p class="text-3">
                        Prepaid electricity is now the preferred method for ZESA to collect payment
                        in
                        Zimbabwe. Traditionally, you would need to wait in long queues to pay your
                        bill at
                        your local branch. This caused a lot of consumer frustration as bill payment
                        was not
                        easily accessible. So, after intensive technology development, platforms
                        like
                        Magetsi were launched
                    </p>
                    <p class="text-3">
                        Magetsi is a feature-rich online self-help service that allows you to buy
                        ZESA token
                        online. The mission was to ensure that prepaid electricity is available to
                        every
                        Zimbabwean without the hassle of leaving the comfort of your home. This is a
                        convenient service that allows you to buy tokens using EcoCash, Mastercard,
                        or Visa
                    </p>
                    <p class="text-3">
                        Our online prepaid service is quick, safe, and straightforward. All you need
                        is an
                        internet connection and your phone, and you can easily buy emergency tokens
                        for
                        those unforeseen electricity emergencies.
                    </p>
                </div>
            </div>
        </section>
        <section class="section py-5 bg-white">
            <div class="container">
                <h2 class="text-9 font-weight-bold mb-5 text-center"> Why Magetsi Online? </h2>

                <div class="row">
                    <div class="col-lg-7 mb-5 p-lg-5">
                        <h5 class="text-5 font-weight-bold mb-2"> Zimbabwe's Favorite Way to Buy ZESA Online</h5>
                        <div class="text-3 text-justify">
                            <p>
                                Magetsi has specialized in the sale of energy tokens and airtime since 2015.
                                However, what has made us Zimbabwe's favorite isn't just experience but rather our
                                dedication to delivering the best and flawless service around. Our primary focus is
                                on the long-forgotten aspect of lovable businesses.
                            </p>
                            <p>
                                As the best online utility experts, we genuinely care about our clients, and
                                everything we do is to exceed our clients' expectations. We believe this is what
                                drives the compliments we receive from our clients on GoogleMyBusiness every day.
                            </p>
                            <p>
                                The Magetsi customer services team can be contacted on WhatsApp 24/7/365. We would
                                love to hear from you, and we look forward to providing easy solutions to all your
                                problems.
                            </p>
                        </div>
                    </div>
                    <div class="col-lg-5 p-lg-5">
                        <img class="rounded-lg shadow-lg w-100" src="/images/favourite-people.jpg" alt="">
                    </div>
                </div>

                <div class="row">
                    <div class="col-lg-5 p-lg-5">
                        <img class="rounded-lg shadow-lg w-100" src="/images/fast-tracking-vs-crashing-article.jpg"
                             alt="">
                    </div>
                    <div class="col-lg-7 p-lg-5">
                        <h5 class="text-5 font-weight-bold mb-2"> Fast & easy to use</h5>
                        <div class="text-3 text-justify">

                            <p>
                                With Magetsi online, you can buy energy tokens using EcoCash in a few minutes. All
                                you need is your phone, an internet connection, and a simple EcoCash payment!
                            </p>

                            <p>
                                But why stop with energy tokens only when you can also buy your airtime online with
                                a single payment? Magetsi's product offering is expanding into broadband, gas,
                                school fees, insurance, wifi bundles, and a whole lot more.
                            </p>

                            <p>
                                The above products and countless others will be added to our platform soon.
                            </p>
                        </div>
                    </div>
                </div>

            </div>
        </section>
        <section class="section py-5 bg-light-4">
            <div class="container">
                <h2 class="text-center text-9 font-weight-bold mb-4"> Electricity Info/Tips </h2>
                <transition-group tag="div" class="row justify-content-center rounded-lg overflow-hidden"
                                  name="slide-in-left">
                    <div key="1" v-if="car === 1" class="col-lg-8">
                        <div class="bg-white shadow-sm rounded mb-4 p-4">
                            <div class="text-sm-start">
                                <h5 class="text-3 text-body">Prepaid vs. Postpaid Electricity</h5>
                                <p class="text-muted mb-0">
                                    Are you still using postpaid meters? There are many reasons why you should
                                    switch to
                                    prepaid and start using services like Magetsi online. Benefits of prepaid
                                    utility bills
                                    include cheaper rates, convenience, better budgeting, and easy and convenient
                                    online
                                    payment methods. As a result, there has been a shift regarding how Zimbabweans
                                    perceive
                                    post vs. prepaid utilities. Here are some of the reasons why.
                                </p>
                            </div>
                        </div>
                    </div>
                    <div key="2" v-if="car === 2" class="col-lg-8">
                        <div class="bg-white shadow-sm rounded mb-4 p-4">
                            <div class="text-sm-start">
                                <h5 class="text-3 text-body">
                                    Buying Prepaid Electricity Online Is As Easy As Pie
                                </h5>
                                <p class="text-muted mb-0">
                                    To pay ZESA online, all you need to do is get your phone and press a few
                                    buttons. There are several platforms, including Magetsi and TechZim ZESA. In a
                                    minute, you can get the power back on and enjoy your movies and music. No hassle
                                    and no lost time. Apart from that, there is no need to plan ahead It's no wonder
                                    why Zimbabweans are so keen to switch to prepaid electricity.
                                </p>
                            </div>
                        </div>
                    </div>
                    <div key="3" v-if="car === 3" class="col-lg-8">
                        <div class="bg-white shadow-sm rounded mb-4 p-4">
                            <div class="text-sm-start">
                                <h5 class="text-3 text-body">Easily Track Energy Consumption</h5>
                                <p class="text-muted">
                                    Budgeting shouldn't have to be a monthly affair. Traditionally, you would need
                                    to wait
                                    until the ZESA guys came to take your meter reading and send you a bill to know
                                    how much
                                    you should set aside for electricity. Unfortunately, that presented a lot of
                                    challenges.
                                    For instance, it was impossible to know how much you spend a day and monitor
                                    which of
                                    your appliances uses the most electricity.
                                </p>
                                <p class="text-muted">
                                    With prepaid meters, tracking your energy consumption has become very easy. The
                                    idea of
                                    knowing your daily expenditure is very appealing to everyone concerned about
                                    their
                                    budget. Research shows that energy awareness results in many changes when it
                                    comes to
                                    power usage behaviors. Once you know how much you are spending daily, there's a
                                    high
                                    chance your energy usage will drop significantly as you are more aware of the
                                    behaviors
                                    that deplete your units.
                                </p>
                                <p class="text-muted mb-0">
                                    Secondly, unlike with traditional bill payments, with prepaid electricity, the
                                    consumer
                                    is the one who decides how much they want to spend on a single purchase. This
                                    means that
                                    it's the consumer who is in control of the situation.
                                </p>
                            </div>
                        </div>
                    </div>
                    <div key="4" v-if="car === 4" class="col-lg-8">
                        <div class="bg-white shadow-sm rounded mb-4 p-4">
                            <div class="text-sm-start">
                                <h5 class="text-3 text-body">Manage Financial Resources Better</h5>
                                <p class="text-muted mb-2">
                                    Having a prepaid meter installed in your home thus allows you to save on your
                                    energy
                                    bill, resulting in better savings. Imagine never having to get an unexpected,
                                    exaggerated monthly account! Therefore, one of the most significant advantages
                                    of
                                    switching to prepaid is that it allows you to better manage your cash flow and
                                    allocate
                                    financial resources appropriately
                                </p>
                                <div class="row text-muted">
                                    <div class="col-6">
                                        <h6>Prepaid Electricity</h6>
                                        <ul>
                                            <li>No contract; you will just pay ZESA online</li>
                                            <li>You can take advantage of online bill payments like paynow ZESA</li>
                                            <li>No disconnection fees</li>
                                            <li>Pay-as-you-go</li>
                                        </ul>
                                    </div>
                                    <div class="col-6">
                                        <h6>Postpaid Electricity</h6>
                                        <ul>
                                            <li>Contracts required</li>
                                            <li>Long queues involved every month end</li>
                                            <li>Termination and reconnection fees</li>
                                            <li>Monthly bills</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div key="5" v-if="car === 5" class="col-lg-8">
                        <div class="bg-white shadow-sm rounded mb-4 p-4">
                            <div class="text-sm-start">
                                <h5 class="text-3 text-body">Magetsi Online - How To...</h5>
                                <p class="text-muted">
                                    Never used Magetsi before? Our goal is to make sure that you can access
                                    easy-to-follow instructions on how to use our platform.
                                </p>
                                <p class="text-muted mb-0">
                                    Please follow this visual tutorial whenever you find yourself stuck on
                                    the Magetsi online platform. Furthermore, if you have friends or family who
                                    might
                                    benefit from this tutorial, you can also forward it to them via a sharable link
                                </p>
                            </div>
                        </div>
                    </div>
                </transition-group>
            </div>
        </section>
        <section class="section mb-0 bg-white">
            <div class="container">
                <h2 class="text-9 font-weight-bold text-center">Magetsi Online FAQ</h2>
                <div class="row">
                    <div class="col-md-12 mx-auto">
                        <div class="row">
                            <div class="col-md-6">
                                <div class="accordion accordion-alternate" id="popularTopics">
                                    <div class="card">
                                        <div class="card-header" id="heading1">
                                            <h5 class="mb-0">
                                                <a href="#" class="collapsed" data-toggle="collapse"
                                                   data-target="#collapse1" aria-expanded="false"
                                                   aria-controls="collapse1">
                                                    I haven't received my token, what might be wrong?</a>
                                            </h5>
                                        </div>
                                        <div id="collapse1" class="collapse" aria-labelledby="heading1"
                                             data-parent="#popularTopics">
                                            <div class="card-body">
                                                There are several reasons why your token might be delayed—these
                                                range from municipal challenges to problems with the network. If you
                                                buy zesa online and didn't receive your token, please contact
                                                Magetsi customer service immediately, and one of our friendly
                                                professional Consultants will help you get your token.
                                            </div>
                                        </div>
                                    </div>
                                    <div class="card">
                                        <div class="card-header" id="heading2">
                                            <h5 class="mb-0"><a href="#" class="collapsed" data-toggle="collapse"
                                                                data-target="#collapse2" aria-expanded="false"
                                                                aria-controls="collapse2">Can I make several
                                                purchases in a short space of time?</a></h5>
                                        </div>
                                        <div id="collapse2" class="collapse" aria-labelledby="heading2"
                                             data-parent="#popularTopics">
                                            <div class="card-body"> Yes, you can indeed! However, to stop you from
                                                making duplicate payments, EcoCash might require you to space out
                                                your purchases by a few minutes so that you don't make the same
                                                transaction twice. This is for your safety to ensure that your
                                                transactions are seamlessly processed.
                                            </div>
                                        </div>
                                    </div>
                                    <div class="card">
                                        <div class="card-header" id="heading8">
                                            <h5 class="mb-0"><a href="#" class="collapsed" data-toggle="collapse"
                                                                data-target="#collapse8" aria-expanded="false"
                                                                aria-controls="collapse8">Can a ZESA token be
                                                reversed?</a></h5>
                                        </div>
                                        <div id="collapse8" class="collapse" aria-labelledby="heading8"
                                             data-parent="#popularTopics2">
                                            <div class="card-body"> Unfortunately, reversing the token once you have
                                                already purchased it is impossible.
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="accordion accordion-alternate" id="popularTopics2">
                                    <div class="card">
                                        <div class="card-header" id="heading6">
                                            <h5 class="mb-0"><a href="#" class="collapsed" data-toggle="collapse"
                                                                data-target="#collapse6" aria-expanded="false"
                                                                aria-controls="collapse6">Does Magetsi have an
                                                app?</a></h5>
                                        </div>
                                        <div id="collapse6" class="collapse" aria-labelledby="heading6"
                                             data-parent="#popularTopics2">
                                            <div class="card-body">
                                                Magetsi currently doesn't have an Android or iOS application.
                                                However, we have an instant link that you can download for easy
                                                access. You can also bookmark our site so that you don't have to
                                                repeatedly enter the website address each time you want to buy ZESA
                                                online.
                                            </div>
                                        </div>
                                    </div>
                                    <div class="card">
                                        <div class="card-header" id="heading7">
                                            <h5 class="mb-0"><a href="#" class="collapsed" data-toggle="collapse"
                                                                data-target="#collapse7" aria-expanded="false"
                                                                aria-controls="collapse7">What is the least amount
                                                that I can purchase?</a></h5>
                                        </div>
                                        <div id="collapse7" class="collapse" aria-labelledby="heading7"
                                             data-parent="#popularTopics2">
                                            <div class="card-body"> The smallest amount for ZESA token purchase is
                                                100 ZWG
                                            </div>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <p class="text-3 mt-5">
                    ZESA online tokens are issued per meter number. This means that once a token has been issued to
                    your meter number, it can only be redeemed on your prepaid meter. Although Magetsi cannot assist
                    you with prepaid token reversal, you can contact ZESA directly to find out how they can help you
                    with your query.
                    <br>
                    <br>
                    Visit and LIKE our Magetsi Facebook page or follow us on Twitter @Magetsi_ZW. We will keep you
                    updated about NEWS and INFORMATION relevant to buying ZESA online on our social media platforms.
                    <br>
                    <br>
                    Click here to see what our users say about the Magetsi service after recharging their meters
                    through our platform. You will be pleasantly surprised!
                </p>
            </div>
        </section>
    </bill-shell>
</template>

<script>
import Carousel from "../custom/carousel.vue";
import BillShell from "./bill-shell.vue";

export default {
    name: "dashboard",
    components: {BillShell, Carousel, WelcomeInfo: () => import("../shared/welcome-info")},
    data: () => ({
        car: 1,
        content: [
            {
                title: 'Buy Prepaid\nZESA Tokens\nFor You or Loved Ones',
                subtitle: 'In just a few clicks, you can buy your prepaid ZESA token and send them to your phone. Also, get a receipt when you purchase using Magetsi. Accepted payment methods on our platform include EcoCash, MasterCard, VISA, and other international cards.',
            },
            {
                title: 'Get Up To\n15% BONUS!!!',
                subtitle: 'When you pay using MasterCard, Visa, or other international cards.'
            }
        ]
    }),

    mounted() {
        const carousel = () => setTimeout(() => {
            if (this.car + 1 > 5) this.car = 1
            else this.car++

            carousel()
        }, 25000)

        carousel()
    },

}
</script>
